import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const TagContainer = styled(motion.div)`
  display: inline-flex;
  align-items: center;
  padding: 10px 20px;
  background-color: ${props => props.bgColor || props.theme.colors.accent1};
  border-radius: 30px;
  font-size: 16px;
  font-weight: 600;
  margin: 4px;
  color: ${props => props.theme.colors.primary};
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
`;

const HashIcon = styled.span`
  margin-right: 4px;
  font-weight: bold;
  font-size: 18px;
  color: ${props => props.theme.colors.primary};
`;

const Tag = ({ label, color }) => {
  return (
    <TagContainer 
      bgColor={color}
      whileHover={{ scale: 1.05 }}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ 
        duration: 0.5,
        hover: { duration: 0.2 }
      }}
    >
      <HashIcon>#</HashIcon>
      {label}
    </TagContainer>
  );
};

export default Tag; 